<template>
	<div class="ce-campaign-topteaser">
		<div
			class="campaign-topteaser-stage"
			:style="'background-image:url(' + objectdata.backgroundimage + ')'"
		>
			<div class="campaign-topteaser-content">
				<div class="campaign-topteaser-logo">
					<img :src="objectdata.logoimage" alt />
				</div>
				<div class="campaign-topteaser-packshot animated">
					<img :src="objectdata.packshotimage" alt />
				</div>
				<div class="campaign-topteaser-discount animated">
					<img :src="objectdata.discountimage" alt />
				</div>
			</div>
		</div>
		<div class="campaign-topteaser-text">
			<div class="content-wrapper">
				<div
					v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value, objectdata.headlinecentered)"
				></div>
				<div
					v-html="getHeadline(objectdata.subheadline.unit, objectdata.subheadline.value, objectdata.headlinecentered)"
				></div>
				<!-- <h3>{{objectdata.headline.value}}</h3>
				<h3>{{objectdata.subheadline.value}}</h3>-->
				<div class="campaign-topteaser-buttons">
					<div class="button-container">
						<a
							@click="gotoPage(objectdata.button_1[0].buttonurl)"
							:alt="objectdata.button_1[0].alttext"
							class="campain-button-01"
							:data-color="objectdata.button_1[0].buttoncolor"
							:style="'background-color:#' + objectdata.button_1[0].buttoncolor"
						>{{objectdata.button_1[0].buttontext}}</a>
					</div>
					<div class="button-container">
						<a
							@click="gotoPage(objectdata.button_2[0].buttonurl)"
							:alt="objectdata.button_2[0].alttext"
							class="campain-button-02"
							:data-color="objectdata.button_2[0].buttoncolor"
							:style="'background-color:#' + objectdata.button_2[0].buttoncolor"
						>{{objectdata.button_2[0].buttontext}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		mounted() {
			this.initAnimation();
			this.setButtonCSS();
		},
		methods: {
			initAnimation() {
				// animate packshot
				let elemPackshot = document.querySelector(
					".campaign-topteaser-packshot"
				);
				let animationNamePackshot = "fadeInRightBig";
				setTimeout(function() {
					elemPackshot.classList.add(animationNamePackshot);
				}, 800);

				// animate rabatt
				let elemRabatt = document.querySelector(
					".campaign-topteaser-discount"
				);
				let animationNameRabatt = "fadeInLeft";
				setTimeout(function() {
					elemRabatt.classList.add(animationNameRabatt);
				}, 800);
			},
			convertHexToRgba(color, opacity) {
				color = color.replace("#", "");
				let r = parseInt(color.substring(0, 2), 16);
				let g = parseInt(color.substring(2, 4), 16);
				let b = parseInt(color.substring(4, 6), 16);
				let result =
					"rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
				return result;
			},
			setButtonCSS() {
				let Btn01 = document.querySelector(".campain-button-01");
				let Btn02 = document.querySelector(".campain-button-02");

				let Btn01Color = Btn01.getAttribute("data-color");
				let Btn02Color = Btn02.getAttribute("data-color");

				let btn01ColorRGBA = this.convertHexToRgba(Btn01Color, 0);
				let btn02ColorRGBA = this.convertHexToRgba(Btn02Color, 0);

				let Btn01ColorNew = this.shadeColor("#" + Btn01Color, 20);
				let Btn02ColorNew = this.shadeColor("#" + Btn02Color, 20);

				let stringStyle =
					".ce-campaign-topteaser .campaign-topteaser-buttons a.campain-button-01:after{background-image: linear-gradient(to top," +
					btn01ColorRGBA +
					"," +
					Btn01ColorNew +
					")} .ce-campaign-topteaser .campaign-topteaser-buttons a.campain-button-02:after{background-image: linear-gradient(to top," +
					btn02ColorRGBA +
					"," +
					Btn02ColorNew +
					")}";
				// add new styles to head
				var cssString = stringStyle;
				let styleblock = document.createElement("style");
				document.head.appendChild(styleblock);
				styleblock.type = "text/css";
				if (styleblock.styleSheet) {
					// This is required for IE8 and below.
					styleblock.styleSheet.cssText = cssString;
				} else {
					styleblock.appendChild(document.createTextNode(cssString));
				}
			},
			shadeColor(color, percent) {
				// 40 = lighten, -40 = darken
				var R = parseInt(color.substring(1, 3), 16);
				var G = parseInt(color.substring(3, 5), 16);
				var B = parseInt(color.substring(5, 7), 16);

				R = parseInt((R * (100 + percent)) / 100);
				G = parseInt((G * (100 + percent)) / 100);
				B = parseInt((B * (100 + percent)) / 100);

				R = R < 255 ? R : 255;
				G = G < 255 ? G : 255;
				B = B < 255 ? B : 255;

				var RR =
					R.toString(16).length == 1
						? "0" + R.toString(16)
						: R.toString(16);
				var GG =
					G.toString(16).length == 1
						? "0" + G.toString(16)
						: G.toString(16);
				var BB =
					B.toString(16).length == 1
						? "0" + B.toString(16)
						: B.toString(16);

				return "#" + RR + GG + BB;
			}
		},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";

	.ce-campaign-topteaser {
		// margin-top: 70px;
		.win & {
			overflow: hidden;
		}
		img {
			height: auto;
			width: 100%;
		}
		.campaign-topteaser-stage {
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center bottom;
			min-height: 500px;
			margin-bottom: 150px;
			padding: 25px 0 50px;
			@include min-screen($screen-min-content) {
				position: relative;
				margin-bottom: 50px;
			}
			@include min-screen($screen-min-l) {
				min-height: 610px;
			}

			.campaign-topteaser-content {
				margin: 0 auto;
				position: relative;
				@include min-screen($screen-min-content) {
					position: absolute;
					left: 50%;
					transform: translate(-50%, -50%);
					top: 50%;
				}

				.campaign-topteaser-logo {
					margin: 0 auto 10px;
					max-width: 175px;
					@include min-screen($screen-min-m) {
						max-width: 205px;
					}
					@include min-screen($screen-min-content) {
						position: absolute;
						left: 0;
						max-width: 230px;
					}
					@include min-screen($screen-min-l) {
						max-width: 280px;
					}
				}
				.campaign-topteaser-packshot {
					opacity: 0;
					margin: 0 auto;
					width: 100%;
					max-width: 285px;
					@include min-screen($screen-min-m) {
						position: relative;
						margin-left: 250px;
						max-width: 395px;
					}
					@include min-screen($screen-min-content) {
						position: relative;
						margin-left: 250px;
						max-width: 445px;
					}
					@include min-screen($screen-min-l) {
						margin-left: 300px;
						max-width: 520px;
					}
				}
				.campaign-topteaser-discount {
					opacity: 0;
					bottom: -150px;
					margin-left: 20px;
					max-width: 265px;
					position: absolute;
					// @include min-screen($screen-min-m) {
					// 	left: 50%;
					// 	transform: translateX(-80%);
					// }
					@include min-screen($screen-min-content) {
						bottom: -17px;
						left: 36px;
						max-width: 230px;
						transform: none;
					}
					@include min-screen($screen-min-l) {
						max-width: 280px;
					}
				}
			}
		}
		.campaign-topteaser-text {
			h1,
			h2,
			h3 {
				display: block;
				padding: 0;
				text-align: center;
				margin: 0 20px 10px;
				&:after {
					border-width: 0;
				}
			}
		}
		.campaign-topteaser-buttons {
			margin-top: 30px;
			@include min-screen($screen-min-s) {
				display: flex;
				justify-content: center;
			}
			.button-container {
				// fix for safari before overflow gradient
				border-radius: 15px;
				overflow: hidden;
				margin-bottom: 15px;
				@include min-screen($screen-min-s) {
					margin-left: 20px;
					&:first-of-type {
						margin-left: 0;
					}
				}
			}
			a {
				color: $color-white;
				cursor: pointer;
				display: inline-block;
				border-radius: 15px;
				line-height: 1;
				font-size: 20px;
				overflow: hidden;
				padding: 20px;
				user-select: none;
				text-align: center;
				text-decoration: none;
				text-overflow: ellipsis;
				transform: translateY(0);
				transition: background-color 0.2s ease-in-out;
				white-space: nowrap;
				width: 100%;
				@include min-screen($screen-min-s) {
					font-size: 25px;
					// margin-left: 20px;
					padding: 10px 20px;
					width: auto;
					// &:first-of-type {
					// 	margin-left: 0;
					// }
					// &.campain-button-01:after {
					// 	background-image: linear-gradient(
					// 		to right,
					// 		transparent,
					// 		#fcb50c
					// 	);
					// }
					// &.campain-button-02:after {
					// 	background-image: linear-gradient(
					// 		to right,
					// 		transparent,
					// 		#ac001c
					// 	);
					// }

					&:after {
						content: "";
						border-radius: 15px;
						width: 100%;
						opacity: 1;
						height: 0;
						// background-image: linear-gradient(
						// 	to right,
						// 	transparent,
						// 	rgba(255, 255, 255, 0.5)
						// );
						position: absolute;
						left: 0;
						bottom: 0;
						z-index: -1;
						transition: height 0.2s cubic-bezier(0.52, 0.85, 0.44, 1);
					}

					&:hover {
						&:after {
							height: 100%;
						}
					}
				}
			}
		}
	}
</style>